module.exports = __webpack_public_path__ + "img/MoDesk5.edf2aad6.png";